import { styled } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { colors } from "@zapalacorp/tokens";
import { RiCloseLine } from "react-icons/ri";

export const BottomButtonContainer = styled("div")(() => ({
  display: "flex",
  marginLeft: "auto",
}));

export const DeleteDocumentIcon = styled(RiCloseLine)(() => ({
  visibility: "hidden",
  cursor: "pointer",
  position: "absolute",
  top: "12px",
  right: "16px",
}));

const styles = makeStyles(() => ({
  topText: {
    fontFamily: "Manrope",
    fontWeight: 600,
    fontSize: 16,
    lineHeight: "22px",
    color: "#465869",
    width: "100%",
  },
  uploadText: {
    fontFamily: "Manrope",
    fontWeight: 500,
    fontSize: 16,
    lineHeight: "24px",
    color: "#308CDB !important",
  },
  bottomText: {
    fontFamily: "Manrope",
    fontWeight: 400,
    fontSize: 14,
    lineHeight: "19px",
    color: "#465869",
  },
  dueText: {
    fontFamily: "Manrope",
    fontWeight: 500,
    fontSize: 14,
    lineHeight: "21px",
    color: "#465869",
  },
  notDefined: {
    color: "#9CA6AF",
    fontFamily: "Manrope",
    fontWeight: 400,
    fontSize: 14,
    lineHeight: "19px",
  },
  bottom: {
    width: "100%",
    marginTop: "17px",
  },
  button: {
    height: "32px",
    padding: "8px 20px",
    fontSize: "13px",
    fontFamily: "Inter",
  },
  uploadButton: {
    fontWeight: 700,
    lineHeight: "17px",
  },
  uploadingButton: {
    backgroundColor: "#F2F4F7",
    color: "#308CDB !important",
    pointerEvents: "none",
  },
  uploadedText: {
    color: "#308CDB !important",
    marginLeft: "8px !important",
  },
  generatedText: {
    color: "#32D583 !important",
    marginLeft: "8px !important",
    width: "max-content",
  },
  uploadTooltip: {
    display: "flex !important",
    marginLeft: "8px !important",
    alignSelf: "flex-start !important",
  },
  colorBlue: {
    color: "#308CDB !important",
  },
  colorRed: {
    color: "#F97066 !important",
  },
  colorGreen: {
    color: "#32D583 !important",
  },
  documentItemBadge: {
    visibility: "visible",
  },
  container: {
    position: "relative",
    borderRadius: "8px",
    background: colors.gray50,
    padding: "12px 16px !important",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "center",
    "&:hover .deletableDocumentItemBadge": {
      visibility: "hidden",
    },
    "&:hover #deleteDocumentIcon": {
      visibility: "visible",
    },
  },
  input: {
    display: "none",
  },
  loading: {
    color: "#308CDB",
    marginRight: "12px",
  },
  divider: {
    margin: "0 25px !important",
  },
  bottomActions: {
    width: "100%",
  },
  archivesList: {
    width: "100%",
    maxHeight: "180px",
    overflowY: "auto",
    backgroundColor: colors.white,
    borderRadius: "6px",
    border: `1px solid ${colors.gray100}`,
  },
  archiveRow: {
    width: "100%",
    gap: "10px",
    padding: "8px 12px",
    borderBottom: `1px solid ${colors.gray100}`,
    "&:last-child": {
      borderBottom: "none",
    },
  },
  archiveFileIcon: {
    flexShrink: 0,
  },
  archiveFilename: {
    fontFamily: "Manrope",
    fontWeight: 500,
    fontSize: 13,
    lineHeight: "18px",
    color: "#465869",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    flex: 1,
    minWidth: 0,
  },
  archiveActions: {
    flexShrink: 0,
    gap: "4px",
  },
  archiveIconButton: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: "28px",
    height: "28px",
    border: "none",
    background: "transparent",
    borderRadius: "4px",
    cursor: "pointer",
    padding: 0,
    "&:hover:not(:disabled)": {
      backgroundColor: colors.gray100,
    },
    "&:disabled": {
      cursor: "not-allowed",
      opacity: 0.5,
    },
  },
  archiveActionLoading: {
    width: "28px !important",
    height: "28px !important",
    padding: "6px",
  },
}));

export default styles;
